import request from '@/router/axios';

export const getList = (params) => {
  return request({
    url: '/api/produce/device-parameter-threshold/select/page',
    method: 'post',
    params
  })
}
export const add = (row) => {
  return request({
    url: '/api/produce/device-parameter-threshold/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/device-parameter-threshold/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/device-parameter-threshold/select/id',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/produce/device-parameter-threshold/delete/ids',
    method: 'post',
    params: {
      ids
    }
  })
}

